import { Component, OnInit, OnDestroy } from '@angular/core'; // Added OnDestroy
import gql from 'graphql-tag';
import { Apollo, QueryRef } from 'apollo-angular';
import { Subscription } from 'rxjs'; // Added Subscription

@Component({
    selector: 'testimonial-slider',
    templateUrl: './testimonial-slider.component.html',
    styleUrls: ['./testimonial-slider.component.scss'],
    standalone: false
})
export class TestimonialSliderComponent implements OnInit, OnDestroy { // Implemented OnDestroy
  testimonialList: any;
  slides: any[] = []; // Explicit type definition
  BANNER_QUERY = gql`
  query  {
    testimonials{
      id
      description
      name
      company
      image {
        id
        fileName
        size
        url
      }
    }
    textBanners{
      id
      textMessage
      updatedAt
    }
  }
`;
  
  slideConfig = {
    "slidesToShow": 3,
    "slidesToScroll": 1,
    "dots": true,
    "arrows": false,
    "infinite": true,
    "loop": true,
    "autoplay": {
      delay: 2000,
    },
    'responsive': [
      { 'breakpoint': 992, 'settings': { 'slidesToShow': 2 } },
      { 'breakpoint': 767, 'settings': { 
        'slidesToShow': 1 ,
        "dots": false,
        "arrows": true,
        "adaptiveHeight":true
      } }
    ]
  };
  
  private query!: QueryRef<any>; // Added definite assignment assertion (!)
  private querySubscription!: Subscription; // Added to manage subscription memory

  constructor(private apollo: Apollo) { }

  ngOnInit(): void {
    console.log(this.apollo)
    this.query = this.apollo.watchQuery({
      query: this.BANNER_QUERY,
      variables: {},
      errorPolicy: 'all' 
    });
    console.log(this.query)
    this.querySubscription = this.query.valueChanges.subscribe({
      next: (result) => {

        if (result.loading) {
          return;
        }

        // FIX: Replaced result.errors with strict result.error check
        if (result.error) {
          console.error('GraphQL execution encountered severe errors:', result.error);
          
          // Safely log inner schema errors if they exist inside the apollo error wrapper
          const apolloError = result.error as any;
          if (apolloError.graphQLErrors) {
            console.error('Detailed Server GraphQL Errors:', apolloError.graphQLErrors);
          }
          return; 
        }

        if (result.data && result.data.testimonials) {
          this.testimonialList = result.data.testimonials;
          this.slides = []; 

          for (let i = 0; i < this.testimonialList.length; i++) {
            this.slides.push({
              img: this.testimonialList[i].image?.url || '',
              testimonialName: this.testimonialList[i].name, 
              companyType: this.testimonialList[i].company, 
              testimonilaMessage: this.testimonialList[i].description
            });
          }
        } else {
          console.warn('HTTP 200 returned but payload data maps to empty structure.', result);
        }
      },
      error: (networkError) => {
        console.error('Fatal network/link connection failure:', networkError);
      }
    });
  }



  // Prevent memory leaks when navigating away from this page component
  ngOnDestroy(): void {
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
  }
}

